import VueRouter from 'vue-router'
import global_routes from "@/core/vue-router/global-routes";
import {addRegionPathToRoutes, overrideRouterPush} from "@/core/utils/helpers/routesHeper";

const routes = _.concat(global_routes, []);

const router = new VueRouter({
    mode: 'history',
    routes: addRegionPathToRoutes(routes),
});

overrideRouterPush( router);

router.beforeEach(to => {
    const index = _.findIndex(global_routes, route => {
        return route.name === to.name;
    });
    if (index > -1) {
        window.location.href = _.get(global_routes, `${index}.path`, '/');
    }
})

router.afterEach((to, from) => {
    utils.updateCanonicalTag(to);

    // XTracking global function
    if (typeof xpv !== 'undefined') {
        xpv(user, to.fullPath);
    }
});

export default router;
